import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/commons/Icon';

import { Wrapper, Content } from './styles';

const ActionButton = ({ icon, children, ...props }) => (
  <Wrapper {...props}>
    {!!icon && <Icon name={icon} />}

    {!!children && <Content>{children}</Content>}
  </Wrapper>
);

ActionButton.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
};

ActionButton.defaultProps = {
  icon: null,
  children: null,
};

export default ActionButton;
